module.exports = __webpack_public_path__ + "img/avatar4.58c12b80.png";